/**
 * @desc 获取加油站油价列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.ResPetrolStationPageParams>): Promise<BaseResponse<defs.PageBean<Array<defs.ResPetrolPriceDto>>>> {
  return fetch({
    url: config.API_HOST + '/base/resPetrolPrice/pageList',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
